/*
 * Get-staff.ts
 * Description: Includes the declaration
 * of the function for updating staff members
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing user interface
import {User} from '@/ts/auth/validate-register';

/**
 * Updating a staff member
 *
 * @return {Object} Promise - an updated staff member
 * @param {String} slug - id of the restaurant
 * @param {Number} userId - id of the user
 * @param {User} data - user data
 */
export function putStaff(data: User, slug: string, userId: number) {
    const jwt = localStorage.getItem('jwt');
    if (data.password.length === 0) {
        delete data.password;
        delete data.password_confirmation;
    }
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/users/' + userId,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
